/* eslint-disable react/jsx-key */
import * as React from 'react';
import * as styles from './TourComponent.css';
import { InlineText1 } from '@cian/ui-kit/typography';
import useIsomorphicLayoutEffect from 'use-isomorphic-layout-effect';

export interface ITourComponentProps {
  tourKey: string;
  onShow: () => void;
}

export const TourComponent = ({ tourKey, onShow }: ITourComponentProps) => {
  const [open, setOpen] = React.useState(false);
  const handleClick = () => {
    setOpen(true);
  };

  useIsomorphicLayoutEffect(onShow, []);

  return (
    <div className={styles['tour']} id={'tourBlock'}>
      <h2 className={styles['title']}>3D-тур по квартире</h2>
      <div className={styles['content']}>
        {open ? (
          <iframe
            frameBorder={0}
            src={`https://s2-maps3d.vrnet.io/cian/${tourKey}`}
            width="100%"
            height="100%"
            allowFullScreen
            sandbox="allow-scripts allow-same-origin"
          />
        ) : (
          <div className={styles['layout']} data-tour={'layout'} onClick={handleClick}>
            <InlineText1 whiteSpace="nowrap" userSelect="none" color="white_100">
              Смотреть 3D-тур
            </InlineText1>
          </div>
        )}
      </div>
    </div>
  );
};
